import {useGetReportDatesByPatient} from '@/features/medical-reports/queries/useGetReportDatesByProject'
import {useMemo} from 'react'

export const useReportDatesListByPatient = ({
    patientId,
    userId,
    medicalRecordReportTypeId,
    enabled,
    limit = 10
}: {
    patientId: string
    userId: string
    medicalRecordReportTypeId: string
    enabled?: boolean
    limit?: number
}) => {
    const query = useGetReportDatesByPatient(
        {
            patientId,
            userId,
            medicalRecordReportTypeId,
            limit,
            page: 1
        },
        {enabled}
    )

    const reportDates = useMemo(() => query.data?.pages.flatMap(page => page.data) ?? [], [query.data])

    return {
        ...query,
        reportDates
    }
}
